import * as yup from 'yup';

export const createValidationSchema = (): yup.AnyObjectSchema => {
  return yup.object({
    email: yup.string().required('common.not_empty').email('customer.enter_valid_email'),
    name: yup.string().required('common.not_empty'),
    customerId: yup.string().required('common.not_empty'),
    note: yup.string().nullable().optional(),
    orderAddNewItem: yup.boolean().optional(),
    orderNoDelivery: yup.boolean().optional(),
    orderShowPrice: yup.boolean().optional(),
    standardOrderEdit: yup.boolean().optional(),
  });
};
